import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store/index';
import { ID, ProductMenu } from '@/types/type';

interface IFavoriteUpdationStore {
  menuItemList: ProductMenu[];
}

@Module({
  dynamic: true,
  store,
  name: 'favoriteUpdationStore',
  namespaced: true,
})
export default class FavoriteUpdationStore extends VuexModule
  implements IFavoriteUpdationStore {
  public menuItemList: ProductMenu[] = [];

  @Mutation
  public setUp(menuItemList: ProductMenu[]) {
    this.menuItemList = JSON.parse(JSON.stringify(menuItemList));
  }

  @Mutation
  public top(id: ID) {
    const tempList: ProductMenu[] = this.menuItemList;
    const index = tempList.findIndex(menu => menu.id === id);
    if (index > 0) {
      const target: ProductMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.unshift(target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public up(id: ID) {
    const tempList: ProductMenu[] = this.menuItemList;
    const index = tempList.findIndex(menu => menu.id === id);
    if (index > 0) {
      const target: ProductMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.splice(index - 1, 0, target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public down(id: ID) {
    const tempList: ProductMenu[] = this.menuItemList;
    const index = tempList.findIndex(menu => menu.id === id);
    if (index < tempList.length) {
      const target: ProductMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.splice(index + 1, 0, target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public bottom(id: ID) {
    const tempList: ProductMenu[] = this.menuItemList;
    const index = tempList.findIndex(menu => menu.id === id);
    if (index < tempList.length) {
      const target: ProductMenu = tempList[index];
      tempList.splice(index, 1);
      tempList.push(target);
      this.menuItemList = tempList;
    }
  }

  @Mutation
  public remove(id: ID) {
    const tempList: ProductMenu[] = this.menuItemList;
    const index = tempList.findIndex(menu => menu.id === id);
    if (index < tempList.length) {
      tempList.splice(index, 1);
      this.menuItemList = tempList;
    }
  }

  public get menuItems(): ProductMenu[] {
    return this.menuItemList;
  }
}

export const favoriteUpdationModule = getModule(FavoriteUpdationStore);
